// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileModal_wrapper__3OQHO","content":"MobileModal_content__3EsQl"};